import AdminLayout from "@/layouts/AdminLayout";
// import PageView from "@/layouts/PageView";

/**
 * 基础路由列表
 * 每个用户都拥有的路由列表
 */

export const baseRouterList = [
    {
        path: '/login',
        name: '登录',
        component: () => import('@/pages/Login'),
        meta: { title: 'menu.login' }
    },
    {
        path: '/Exp403',
        name: 'Exp403',
        component: () => import('@/pages/exception/403')
    },
    {
        path: '/Exp500',
        name: 'Exp500',
        component: () => import('@/pages/exception/500')
    },
    {
        path: '/',
        name: '首页',
        component: AdminLayout,
        meta: { title: 'menu.home' },
        redirect: '/workplace',
        children: [
            {
                path: '/workplace',
                name: '工作台',
                component: () => import('@/pages/Workplace'),
                meta: { title: 'menu.workplace' }
            },
            {
                path: '/setting',
                name: '个人设置',
                component: () => import('@/pages/mine/Setting'),
                meta: { title: 'menu.setting' }
            }
        ]
    }
];